<template>
  <div class="farmcommentApp" :style="'height:'+curHeight+'px;background:url('+bg+') no-repeat;background-size:100% 100% !important;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:55px;"></div>
    <div class="pl">
      <h2>您的日志：</h2>
      <input type="text" v-model="title" placeholder="请输入菜园日志标题！"/>
      <textarea v-model="content" placeholder="请输入菜园日志情况！"></textarea>
      <div class="upload">
        <div @click="getQquey" class="img" :style="'background:url('+baseUrl+img+') no-repeat;background-size: 100% 100%'">{{img == '' ? '上传图片' : ''}}</div>
        <!--<span @click="save">上传图片</span>-->
      </div>
      <button @click="save">提交</button>
    </div>
    
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        userData:[],
        baseUrl:'',
        code:'',
        content:'',
        title:'',
        bg:require('../../assets/images/farm.png'),
        img:''
      };
    },

    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/farm');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      save:function(){
        if(this.title == ''){
          this.$alert('请输入日志标题！', '警告', {
            confirmButtonText: '确定',
            showClose:false
          });
          return false;
        }
        if(this.content == ''){
          this.$alert('请输入日志情况！', '警告', {
            confirmButtonText: '确定',
            showClose:false
          });
          return false;
        }
        if(this.img == ''){
          this.$alert('请上传日志图片！', '警告', {
            confirmButtonText: '确定',
            showClose:false
          });
          return false;
        }
        var that = this;
        that.fullscreenLoading = true;
        var id = this.$route.query.id;
        that.axios({
          method:'post',
          url:that.$host+'home/farm/saveLog',
          params:{
            content:that.content,
            user_id:that.userData.id,
            farm_id:id,
            title:that.title,
            img:that.img
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          if(response.data.status == 200){
            that.$router.go(-1);
          }else{
            that.$alert(response.data.message, '警告', {
              confirmButtonText: '确定',
              showClose:false
            });
          }
        }).catch(err=>{

        });
        
      },

      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'chooseImage',
              'getLocalImgData'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['chooseImage'],
              success: function (res) {
                wx.chooseImage({
                  count: 1,
                  sizeType: ['compressed'],
                  sourceType: ['camera'], 
                  success: function(res) {
                      that.fullscreenLoading = true;
                      var localId = res.localIds[0].toString();
                      wx.getLocalImgData({
                          localId: localId, // 图片的localID
                          success: function(res) {
                            var u = navigator.userAgent;
                            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
                            var s = res.localData;
                            if(isAndroid){
                              s = 'data:image/jpg;base64,'+res.localData
                            }
                              //alert(res.localData.replace('data:image/jpeg/png;base64,',''))
                              that.getAjax(s)
                          }
                      });
                  }
                })
              }
            });
            
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
      getAjax:function(localData){
        var that = this;
        $.ajax({
          url:this.$host+'home/farm/upload',
          method: 'post',
          data:{
            localData:localData
          },
          success:function(msg){
            that.img = msg.data
            that.fullscreenLoading = false;
          }
        })
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .farmcommentApp{
    max-width:640px;
    margin:0 auto;
    background-size: 100% 100%;
    overflow-y: scroll;
  }
  .farmcommentApp .pl{
    background: rgba(255,255,255,0.8);
    border-radius: 10px;
    display:block;
    width:92%;
    margin:0 auto;
    padding-bottom:30px;
  }
  .farmcommentApp .pl h2{
    display:block;
    width:92%;
    margin:0 auto;
    color:#999;
    font-size:15px;
    padding:10px 0
  }
  .farmcommentApp .pl input{
    display:block;
    width:86%;
    margin:0 auto;
    height: 30px;
    background: rgba(255, 255, 255, 0);
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.15);
    border-radius: 10px;
    border:none;
    outline:none;
    padding:10px;
    margin-bottom:15px
  }
  .farmcommentApp .pl textarea{
    display:block;
    width:86%;
    margin:0 auto;
    height: 250px;
    background: rgba(255, 255, 255, 0);
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.15);
    border-radius: 10px;
    border:none;
    outline:none;
    padding:10px
  }
  .farmcommentApp .pl button{
    display:block;
    width:92%;
    height: 40px;
    background: #00D138;
    border-radius: 10px;
    border:none;
    margin:0 auto;
    color:#fff;
    font-size:15px;
    margin-top:30px
  }
  .farmcommentApp .pl .upload:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .farmcommentApp .pl .upload{
    display:block;
    width:92%;
    margin:15px auto;

  }
  .farmcommentApp .pl .upload .img{
    float:left;
    width:35%;
    height:91px;
    margin-right:15px;
    border-radius: 5px;
    border:solid 1px #ccc;
    font-size:16px;
    text-align:center;
    line-height:91px;
    color:#999
  }
  /*.farmcommentApp .pl .upload span{
    float:left;
    width:35%;
    border:solid 1px #ccc;
    height:91px;
    text-align:center;
    line-height:91px;
    font-size:16px;
    border-radius: 5px;
    color:#999
  }*/

</style>